import OrderOptimizerRailyListingTableColumn from "../common/types/order-optimizer-raily-listing-table-column";

const getColumns = (): OrderOptimizerRailyListingTableColumn[] => {
  const tableColumns: OrderOptimizerRailyListingTableColumn[] = [
    {
      header: "",
      title: "",
      accessor: "row",
    },
  ];
  return tableColumns;
};

const orderOptimizerRailyListingTableHelper = { getColumns };

export default orderOptimizerRailyListingTableHelper;
